export default __webpack_public_path__ + "static/media/51_BottomLeftSquares_Right.724a2af9.mp4";